<template>
  <div class="virtualGoodsRefund">
    <van-popup v-model="show" round position="bottom" closeable :style="{ height: '50%' }" :lazy-render="false">
      <div class="title">虚拟商品退款</div>
      <div class="main_info">
        <div class="item">
          <span class="label">商品名称：</span>
          <span class="value">{{ data.goodsName }}</span>
        </div>
        <div class="item">
          <span class="label">商品数量：</span>
          <span class="value">{{ data.goodsCount }}件</span>
        </div>
        <div class="item">
          <span class="label">商品金额：</span>
          <span class="value">{{ data.goodsPrice }}元</span>
        </div>
        <div class="item">
          <span class="label">券码信息：</span>
          <span class="value">{{ data.couponCode }}</span>
        </div>
        <div class="item">
          <span class="label">退款原因：</span>
          <div class="value">
            <van-radio-group v-model="radio" icon-size="16px">
              <van-radio
                v-for="(item, index) in groupInfo"
                :key="index"
                :name="item.rid"
                checked-color="#f8d541"
              >{{ item.value }}</van-radio>
            </van-radio-group>
          </div>
        </div>
      </div>
      <div class="btn">
        <van-button class="cancel" round type="default" @click="onChangeShow">取消</van-button>
        <van-button round type="info" @click="ConfirmRefund">确认退款</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import http from "@/utils/axios";
import { Toast } from 'vant';
export default {
  name: 'virtualGoodsRefund',
  data() {
    return {
      show: false,
      data: {},
      radio: '1',
      groupInfo: [],
      param: {
        orderItemId: '',
        refundReason: ''
      },
      role: 'user'
    }
  },
  methods: {
    onChangeShow() {
      this.show = !this.show
    },
    /**
     * 确认退款
     */
    ConfirmRefund() {
      this.toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '退款中...',
      });
      this.param.orderItemId = this.data.orderItemId
      this.groupInfo.forEach(item => {
        if (item.rid === this.radio) {
          this.param.refundReason = item.name;
          this.param.reasonDetailId = item.rid;
          this.param.reasonDetailDesc = item.value
        }
      })
      http({
        url: "order/app/newafter/virtualGoodsRefund",
        method: "post",
        parmes: this.param
      }).then(res => {
        if (res.code === 200) {
          Toast.success(res.message || '退款成功！');
          Toast.clear();
          // 判断来自于哪个端
          if (this.role === 'bees') {
            this.$router.push({ path:'/normalorder'})
          } else {
            this.$router.push({ path:'/order'})
          }
        } else {
          Toast.fail(res.message || '退款失败！');
          Toast.clear();
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.virtualGoodsRefund {
  .title {
    font-size: 32px;
    font-weight: 500;
    color: #000;
    text-align: center;
    margin: 27px 0 40px 0;
  }

  .main_info {
    padding-left: 60px;

    .item {
      display: flex;
      font-size: 26px;
      margin-bottom: 20px;

      .label {
        color: #333;
        font-weight: 500;
        margin-right: 40px;
      }

      .value {
        color: #999;

        .van-radio {
          margin-bottom: 20px;

          /deep/ .van-radio__label {
            font-size: 26px;
            color: #999;
          }
        }
      }
    }
  }

  .btn {
    display: flex;
    padding: 40px 60px;

    /deep/ .van-button {
      width: 300px;
      height: 70px;
      background: #F8D541;
      font-size: 24px;
      color: #333;
      font-weight: 500;
      border: none;
    }

    .cancel {
      background: #fff;
      border: 1px solid #999999;
      color: #999999;
      margin-right: 30px;
    }
  }
}
</style>